import { BasicData } from "helpers/types";
import { createContext } from "react";

export const SourceContext = createContext<{ sources: BasicData[] }>({
  sources: [],
});
